module.exports = __webpack_public_path__ + "static/media/bg.4fa604f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/inviteNewUsers/index/image/bg.png
// module id = 1124
// module chunks = 0